import { render, staticRenderFns } from "./InviteCoordinators.vue?vue&type=template&id=326b4ec2&"
import script from "./InviteCoordinators.vue?vue&type=script&lang=js&"
export * from "./InviteCoordinators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports